import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { SchemasFactory, ContentFactory, Content } from '../../squidex';
import { Observable } from 'rxjs';
import { AppTokenService } from '../../../app-token.service';

@Injectable({
    providedIn: 'root'
})
export class MenuService extends BaseService {

    constructor(schemasFactory: SchemasFactory,
        contentFactory: ContentFactory) {
        super(AppTokenService.MENU_SCHEMA_NAME, contentFactory);
    }

    getFirstContent(): Observable<Content> {
        this.initialize();
        return this.contentService.getFirstContent();
    }

}
